export type NgxDatablePageInfo = {
  count: number;
  limit: number;
  offset: number;
  pageNumber: number;
  pageSize: number;
};

export type NgxDatatableSortInfo = {
  sorts: [
    {
      dir: "asc" | "desc";
      prop: string;
    },
  ];
};

export type NgxDatatablePage<T> = {
  data: T[];
  pageInfo: NgxDatablePageInfo;
  sortInfo?: NgxDatatableSortInfo;
};

export const defaultPageSize = 25;

export const initialPage: NgxDatatablePage<any> = {
  data: [],
  pageInfo: { count: 0, limit: defaultPageSize, offset: 0, pageNumber: 0, pageSize: defaultPageSize },
};
